import { Component } from "react";
import { toast } from "react-toastify";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { showLoader, hideLoader } from "../Settings/SettingHelper";
import { companyName, currency, paymentImage } from "../Settings/Config";
class OmisePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      holdername: "",
      cardNumber: "",
      expiration_month: "",
      expiration_year: "",
      security_code: "",
      cardImage: "",
      omisecodeerror: "",
      omiseyearerror: "",
      omisemontherror: "",
      omisecardrror: "",
      omisenameerror: "",
      openomisePopup: false,
    };
  }
  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://cdn.omise.co/omise.js";
    script.async = true;
    document.body.appendChild(script);
  }

  pad(d) {
    return d < 10 ? "0" + d.toString() : d.toString();
  }

  handleChangeTxt = (item, event) => {
    const re = /^[0-9 \b]+$/;
    if (item == "cardNumber") {
      if (event.target.value === "" || re.test(event.target.value)) {
        var cardnumber = this.space(event.target.value);
        var cardnumberLenght = cardnumber.length;
        if (cardnumberLenght <= 19) {
          this.setState({ [item]: cardnumber });
          this.cardValidation(cardnumber);
        }
      }
    } else if (
      item == "expiration_month" ||
      item == "expiration_year" ||
      item == "security_code"
    ) {
      if (event.target.value === "" || re.test(event.target.value)) {
        this.setState({ [item]: event.target.value });
      }
    } else {
      this.setState({ [item]: event.target.value });
    }

    this.setState({
      omisenameerror: "",
      omisecardrror: "",
      omisemontherror: "",
      omiseyearerror: "",
      omisesecurity_codeerror: "",
    });
  };

  space(el) {
    var numbes = el.replace(/ /g, "");
    return numbes.replace(/(\d{4})/g, "$1 ").replace(/(^\s+|\s+$)/, "");
  }

  cardValidation(carnumber) {
    var imagename = "";
    if (carnumber != "") {
      var single = carnumber.substring(0, 1);
      var double = carnumber.substring(0, 2);

      if (single == 4) {
        imagename = "visa";
      } else if (double == 34 || double == 37) {
        imagename = "american";
      } else if (double >= 51 && double <= 55) {
        imagename = "master";
      } else if (double == 60 || double == 64 || double == 65) {
        imagename = "discover";
      }
    }
    this.setState({ cardImage: imagename });
  }

  generateOmiseToken() {
    if (this.props.omiseKey !== "") {

      var errorFlg = 0,
        omisenameerror = "",
        omisecardrror = "",
        omisemontherror = "",
        omiseyearerror = "",
        omisecodeerror = "";
      if (this.state.holdername == "") {
        errorFlg++;
        omisenameerror = "omise-form-error";
      }
      if (this.state.cardNumber == "") {
        errorFlg++;
        omisecardrror = "omise-form-error";
      }
      if (this.state.expiration_month == "") {
        errorFlg++;
        omisemontherror = "omise-form-error";
      }
      if (this.state.expiration_year == "") {
        errorFlg++;
        omiseyearerror = "omise-form-error";
      }
      if (this.state.security_code == "") {
        errorFlg++;
        omisecodeerror = "omise-form-error";
      }

      this.setState({
        omisenameerror: omisenameerror,
        omisecardrror: omisecardrror,
        omisemontherror: omisemontherror,
        omiseyearerror: omiseyearerror,
        omisecodeerror: omisecodeerror,
      });
      console.log(errorFlg, "errorFlgerrorFlgerrorFlg");
      if (errorFlg === 0) {
        showLoader("prcessOmise");
        window.Omise.setPublicKey(this.props.omiseKey);
        var card = {
          name: this.state.holdername,
          number: this.state.cardNumber,
          expiration_month: this.state.expiration_month,
          expiration_year: this.state.expiration_year,
          security_code: this.state.security_code,
          livemode: false,
        };
        const $this_ = this;
        window.Omise.createToken("card", card, function (statusCode, response) {
          console.log(response, "responseresponseresponse");
          if (statusCode === 200) {
            $this_.props.processToken(response.id);
          } else {
            const errorMsgs =
              response?.message ?? "Something is wrong try again";
            toast.error(errorMsgs);
            hideLoader("prcessOmise");
          }
        });
      }
    }
  }

  render() {
    return (
      <div>
        <Popup
          open={this.props.openomisePopup}
          onClose={() => this.props.updateStateValue("openomisePopup", false)}
          modal
          closeOnDocumentClick={false}
          className="popup-master-small omise-payment"
        >
          <div id="pay-omiseconf-popup" className="pay-omiseconf-popup">
            <div
              className="omise-error-info-div"
              id="omise-error-info-div"
              data-timeoutid=""
              style={{ display: "none" }}
            >
              <div className="container">
                <span className="omise-error-icon">
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  ></i>
                </span>
                <a
                  href="#"
                  className="omise_alert_close"
                  data-dismiss="alert"
                  aria-label="Close"
                  onClick={(evt) => {
                    evt.preventDefault();
                  }}
                >
                  {" "}
                  <span aria-hidden="true">×</span>{" "}
                </a>
                <p className="omise-error-msg">Something went wrong</p>
              </div>
            </div>

            {this.props.omise_envir === "dev" && (
              <div className="omisepay-mode-option">Test Mode</div>
            )}

            <div className="custom_alert">
              <div className="custom_alertin">
                <div className="alert_height">
                  <div className="omise_pay_header">
                    <span className="omise-pay-img">
                      <img
                        className="omise-logo-img"
                        src={paymentImage}
                        alt={companyName}
                      />
                    </span>
                    <span className="omise-pay-title">{companyName}</span>
                  </div>
                  <div className="omise_pay_body">
                    <div className="omisepop_in">
                      <div className="form_sec">
                        <div
                          className={"uname-box " + this.state.omisenameerror}
                        >
                          <i className="fa fa-user" data-unicode="f007"></i>
                          <input
                            type="text"
                            id="holdername"
                            className="form-control"
                            placeholder="Card Holder Name"
                            value={this.state.holdername}
                            onChange={this.handleChangeTxt.bind(
                              this,
                              "holdername"
                            )}
                          />
                        </div>

                        <div
                          className={
                            "card-numbr-div " + this.state.omisecardrror
                          }
                        >
                          <i
                            className="fa fa-credit-card"
                            data-unicode="f09d"
                          ></i>
                          <input
                            type="text"
                            className={"form-control " + this.state.cardImage}
                            placeholder="Card Number"
                            value={this.state.cardNumber}
                            id="omise_card_number"
                            onChange={this.handleChangeTxt.bind(
                              this,
                              "cardNumber"
                            )}
                          />
                          <span className="card"></span>
                        </div>

                        <div className="form_expire_row">
                          <div className="expire_row_inner">
                            <div
                              className={
                                "expire_left " + this.state.omisemontherror
                              }
                            >
                              <i
                                className="fa fa-calendar-o"
                                data-unicode="f133"
                              ></i>
                              <input
                                type="text"
                                className="form-control"
                                maxLength="2"
                                id="expiration_month"
                                placeholder="MM"
                                value={this.state.expiration_month}
                                onChange={this.handleChangeTxt.bind(
                                  this,
                                  "expiration_month"
                                )}
                              />
                            </div>

                            <div
                              className={
                                "expire_mdl " + this.state.omiseyearerror
                              }
                            >
                              <input
                                type="text"
                                placeholder="YY"
                                className="form-control"
                                maxLength="4"
                                id="expiration_year"
                                value={this.state.expiration_year}
                                onChange={this.handleChangeTxt.bind(
                                  this,
                                  "expiration_year"
                                )}
                              />
                            </div>

                            <div
                              className={
                                "expire_right " + this.state.omisecodeerror
                              }
                            >
                              <i className="fa fa-lock" data-unicode="f023"></i>
                              <input
                                type="password"
                                maxLength="3"
                                className="form-control"
                                id="security_code"
                                placeholder="CVV"
                                value={this.state.security_code}
                                onChange={this.handleChangeTxt.bind(
                                  this,
                                  "security_code"
                                )}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="alt_btns">
                          {this.props.omiseKey !== "" && this.props.enableOmise === true && (
                              <button
                                className="button omise-pay-btn"
                                id="prcessOmise"
                                onClick={this.generateOmiseToken.bind(this)}
                              >
                                Pay {currency}{" "}
                                {parseFloat(this.props.payAmount).toFixed(2)}
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}

export default OmisePayment;
